import { useQuery } from "@tanstack/react-query";
import EstateService from "../../services/EstateService";
import useEstatesFilterStore from "../stores/useEstatesFilterStore";

const INITIAL_DATA = {
  estates: [],
  totalCount: 0,
};

const useEstates = () => {
  const state = useEstatesFilterStore((state) => state);
  const {
    page,
    pageSize,
    search,
    searchFilter,
    purpose,
    purposeStatus,
    category,
    subCategory,
    agent,
    representatives,
    offices,
    displayStatus,
    status,
    priceMin,
    priceMax,
    isTopParent,
  } = state;

  return useQuery({
    queryKey: [
      "estates",
      page,
      pageSize,
      search,
      searchFilter,
      purpose,
      purposeStatus,
      category,
      subCategory,
      agent,
      representatives,
      offices,
      displayStatus,
      status,
      priceMin,
      priceMax,
      isTopParent,
    ],
    queryFn: () =>
      EstateService.getEstates({
        page,
        limit: pageSize,
        search: {
          key: searchFilter,
          value: search,
        },
        purpose,
        purposeStatus,
        category,
        subCategory,
        agent,
        representatives,
        offices,
        displayStatus,
        status,
        priceMin,
        priceMax,
        isTopParent: isTopParent == true ? true : null,
      }),
    initialData: INITIAL_DATA,
  });
};

export default useEstates;
